import React, { Fragment, useEffect, useState } from 'react'
import { Button, Tooltip, Row } from 'antd'
import { LoadingOutlined, PrinterOutlined } from '@ant-design/icons'
import proposals from 'egi/consumers/proposals'
import { useProposal, useStep } from 'hooks'
import ReactDOM from 'react-dom'
import { FormInstance } from 'antd/lib/form'
import StringToHtml from 'components/StringToHtml/StringToHtml'
import { PdfPreview } from 'components'

function Minuta ({ formRef }: {formRef: FormInstance}) {
  const [loading, setLoading] = useState<boolean>(false)
  const [contract, setContract] = useState<string>('')
  const proposal = useProposal()

  const step = useStep()

  const resetFields = () => {
    formRef.resetFields()
  }

  async function getPreview () {
    if (!proposal.id) return

    try {
      setLoading(true)
      const response: any = await proposals.preview({ proposalId: proposal.id, stepId: step._id, areaId: step.areaId })
      setContract(response.data.contract)
      setLoading(false)
    } catch (err) {
      console.error(err)
      setLoading(false)
    }
  }

  useEffect(() => {
    if (step.signatures && step.signatures[0] && step.signatures[0].contract) {
      const contract = step.signatures[0].contract
      setContract(contract.signed)
    } else {
      getPreview()
    }
    resetFields()
  }, [step])

  useEffect(() => {
    if (step.signatures && step.signatures[0] && step.signatures[0].contract) {
      const signature = step.signatures[0]
      const signatureInput = document.getElementById('signatureInput')
      const signatureCanvas = (<img src={signature.sign} />)
      if (signatureInput) {
        ReactDOM.render(signatureCanvas, signatureInput)
      }
    }
  }, [])

  async function printContract (watermarkText?: string) {
    const width = window.innerWidth
    const height = window.innerHeight
    const page = await window.open('', '_blank', `channelmode=yes,resizable=yes,width=${width},height=${height}`)
    const watermarkElement = document.querySelectorAll('#contract p.watermark')
    if (page) {
      if (watermarkText && watermarkElement) {
        if (watermarkElement && watermarkElement[0]) watermarkElement[0].innerHTML = watermarkText
      }

      const contractHtml = document.getElementById('contract')?.innerHTML
      if (contractHtml) {
        page.document.body.innerHTML = contractHtml
        setTimeout(() => {
          page.window.print()
          page.window.onafterprint = () => page.window.close()
        }, 500)
      }
    }
  }

  return (
    <div className="final-contract mb-5">
      {loading
        ? <Row
          className="context"
          justify="center"
        >
          <LoadingOutlined />
        </Row>
        : <>
          {step.files?.length
            ? (<PdfPreview src={step.files[0].file} height='750px' />)
            : <StringToHtml value={contract} />}
        </>
      }

      <div className="final-contract__container-signature">
        <Row className="gap-2">
          <Tooltip title="Imprimir via não negociável" destroyTooltipOnHide={{ keepParent: false }}>
            <Button
              onClick={() => printContract('NÃO NEGOCIÁVEL')}
              icon={<PrinterOutlined />}
              className="m-0"
              type="ghost"
            >
              Imprimir via não negociável
            </Button>
          </Tooltip>

          <Tooltip title="Imprimir via negociável" destroyTooltipOnHide={{ keepParent: false }}>
            <Button
              onClick={() => printContract('NEGOCIÁVEL')}
              icon={<PrinterOutlined />}
              className="m-0"
              type="ghost"
            >
              Imprimir via negociável
            </Button>
          </Tooltip>
        </Row>
      </div>
    </div>
  )
}

export default Minuta
